/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1026
 */

"use strict"

exports.a = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}
